module.exports = __webpack_public_path__ + "img/filter.6dd1533b.svg";